import script from "./YesNoBar.vue?vue&type=script&lang=js"
export * from "./YesNoBar.vue?vue&type=script&lang=js"

export default script